export default function AnimateTabBtns() {
  const tabsWrapper = document.querySelectorAll<HTMLDivElement>(".js-content-tabs-wrapper");

  tabsWrapper.forEach((wrapper) => {
    const tabs = wrapper.querySelectorAll<HTMLButtonElement>(".js-tab-btn");
    const sections = wrapper.querySelectorAll<HTMLDivElement>(".js-tab-section");

    if (tabsWrapper && tabsWrapper && tabsWrapper.length > 0) {
      const handleClick = (index: number) => {
        tabs.forEach((tab: HTMLButtonElement, i: number) => {
          if (index === i) {
            tab.setAttribute("data-active", "true");
          } else {
            tab.setAttribute("data-active", "false");
          }
        });

        sections.forEach((section: HTMLDivElement, i: number) => {
          if (index === i) {
            section.setAttribute("data-active", "true");
            section.setAttribute("aria-hidden", "false");
          } else {
            section.setAttribute("data-active", "false");
            section.setAttribute("aria-hidden", "true");
          }
        });

        handleRemoveAnimation();
      };

      const handleOverBtnAnimation = (hoverIndex: number) => {
        const activeIndex = [...tabs].findIndex((tab) => tab.getAttribute("data-active") === "true");

        if (activeIndex !== hoverIndex) {
          if (activeIndex > hoverIndex) {
            tabs[activeIndex].classList.add("animate-btn-left");
          }

          if (activeIndex < hoverIndex) {
            tabs[activeIndex].classList.add("animate-btn-right");
          }
        }
      };

      const handleRemoveAnimation = () => {
        tabs.forEach((tab) => {
          tab.classList.remove("animate-btn-left");
          tab.classList.remove("animate-btn-right");
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => handleClick(index));
      });

      tabs.forEach((tab, index) => {
        tab.addEventListener("mouseover", () => handleOverBtnAnimation(index));
      });

      tabs.forEach((tab) => {
        tab.addEventListener("mouseleave", handleRemoveAnimation);
      });
    }
  });
}
